<template>
  <div id="editor">
    <div class="navbar navbar-dark bg-dark navbar-fixed-left">
      <ul class="nav navbar-nav nav-fixed-top">
        <li class="nav-item">
          <router-link :to="{ name: 'snippets.index' }" class="nav-link btn btn-lg" active-class="active">
            <b-icon-sticky></b-icon-sticky>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{ name: 'documents.index' }" class="nav-link btn btn-lg" active-class="active">
            <b-icon-layout-text-sidebar></b-icon-layout-text-sidebar>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{ name: 'playlists.index' }" class="nav-link btn btn-lg" active-class="active">
            <b-icon-music-note-list></b-icon-music-note-list>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{ name: 'songs.index' }" class="nav-link btn btn-lg" active-class="active">
            <b-icon-music-note-beamed></b-icon-music-note-beamed>
          </router-link>
        </li>

        <li class="nav-item">
          <a @click="logOut" class="nav-link btn">
            <b-icon-x-square-fill></b-icon-x-square-fill>
          </a>
        </li>
      </ul>

      <div class="nav navbar-nav nav-fixed-bottom">
        <div class="nav-item">
          <Broadcaster></Broadcaster>
        </div>
      </div>

    </div>

    <router-view></router-view>
  </div>
</template>

<script>
  import Broadcaster from '../components/Broadcaster';

  export default {
    components: {
      Broadcaster
    },

    methods: {
      logOut() {
        if (window.confirm('Log out?')) {
          this.$store.dispatch('logOut');
          this.$router.push({ name: 'login' })
        }
      }
    }
  }
</script>

<style scoped>
  #editor {
    height: 100%;
  }

  .navbar-fixed-left {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 4rem;
    
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .navbar-nav {
    width: 3rem;
  }

  .nav-link {
    text-align: center;
  }

  .nav-fixed-top {
    position: absolute;
    top: 0.5rem;
  }

  .nav-fixed-bottom {
    position: absolute;
    bottom: 0.5rem;
  }
</style>
